'use client';

import type { ReactNode } from 'react';

interface DecorativeHeaderProps {
  children: ReactNode;
}

export default function DecorativeHeader({ children }: DecorativeHeaderProps) {
  return (
    <div className="relative mt-3 flex w-full justify-center">
      {/* Divider SVG */}
      <Divider />
      {/* Title */}
      <p className="typo-body-4 text-g-00">{children}</p>
    </div>
  );
}

function Divider() {
  return (
    <div className="absolute -top-3 h-4 w-[320px] shrink-0 overflow-hidden">
      {/* Glow */}
      <svg
        className="absolute left-1/2 top-[2px] -translate-x-1/2"
        width="320"
        height="16"
        viewBox="0 0 320 16"
        fill="none"
      >
        <g filter="url(#filter0_f_divider)">
          <path
            d="M-0.000488281 12H102L119.5 2H200.25L219 12H320"
            stroke="var(--color-decorative-divider-stroke)"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_divider"
            x="-4.00049"
            y="-2.5"
            width="328"
            height="19"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood result="BackgroundImageFix" floodOpacity="0" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
          </filter>
        </defs>
      </svg>

      {/* Line */}
      <svg
        className="absolute left-1/2 top-[2px] -translate-x-1/2"
        width="320"
        height="12"
        viewBox="0 0 320 12"
        fill="none"
      >
        <path d="M0 11H102L119.5 1H200.25L219 11H320" stroke="var(--color-decorative-divider-stroke)" />
      </svg>

      {/* Light */}
      <svg
        className="absolute -left-[7.5px] top-[10px]"
        width="132"
        height="7"
        viewBox="0 0 132 7"
        fill="none"
      >
        <path
          style={{ mixBlendMode: 'color-dodge' }}
          d="M58.4417 0.00580999C99.0427 -0.119141 131.975 1.78532 131.999 4.26714C132.024 6.74896 99.1419 8.86455 58.5491 8.99381C17.9564 9.12307 -14.9757 7.2143 -15.0005 4.73248C-15.0335 2.25065 17.8489 0.13507 58.4417 0.00580999Z"
          fill="url(#paint0_radial_light)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_light"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(58.6551 2.84043) rotate(-90.6521) scale(4.56699 73.4585)"
          >
            <stop stopColor="#F5F5F5" />
            <stop offset="0.05" stopColor="#C7C7C7" />
            <stop offset="0.09" stopColor="#9C9C9C" />
            <stop offset="0.14" stopColor="#777777" />
            <stop offset="0.2" stopColor="#565656" />
            <stop offset="0.25" stopColor="#3B3B3B" />
            <stop offset="0.32" stopColor="#252525" />
            <stop offset="0.4" stopColor="#141414" />
            <stop offset="0.49" stopColor="#080808" />
            <stop offset="0.63" stopColor="#010101" />
            <stop offset="1" stopColor="transparent" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
}
